import { createTRPCClient, createWSClient, wsLink } from '@trpc/client';
import type { AppRouter } from '../../../console-server/src/main';
import type { GameId } from 'shared/modelTypes/index';
import type { PersonalityColor } from 'shared/modelTypes/team-kleuren';
import type { KwaliteitenJachtCard } from 'shared/modelTypes/kwaliteiten-jacht';

const wsClient = createWSClient({
	url: import.meta.env.VITE_WEBSOCKET_URL,
});

export const rpc = createTRPCClient<AppRouter>({
	links: [wsLink<AppRouter>({ client: wsClient })],
});

type PlayerState = {
	gameId: number;
	playerId: string;
	sessionId: string;
	gameToPlay?: GameId;
	// lastScreen?: TeamKleurenUpdate;

	answer: string;
	lastAnswerCorrect?: boolean;

	name?: string;
	color?: string;
	companyOrFunction?: string;
	goodCards: { name: string; color: PersonalityColor }[];
	badCards: { name: string; color: PersonalityColor }[];
	score: number;
	numberOfPlayers: number;

	kwaliteitenCards: KwaliteitenJachtCard[];
};

const _state: PlayerState = {
	//
	gameId: -1,
	playerId: '',
	sessionId: '',
	goodCards: [],
	badCards: [],
	score: 0,
	kwaliteitenCards: [],
	answer: '',
	numberOfPlayers: 0,
};

function saveState() {
	localStorage.setItem('player-state', JSON.stringify(_state));
}

function restoreState() {
	const json = localStorage.getItem('player-state');
	if (json) {
		const s = JSON.parse(json);
		for (const [k, v] of Object.entries(s)) {
			// @ts-expect-error it's fine
			_state[k] = v;
		}
	}
	// console.log('player state', JSON.stringify(_state));
}

export const State = new Proxy(_state, {
	get(target, p, _receiver) {
		// @ts-expect-error it's fine
		return target[p];
	},
	set(target, p, newValue) {
		// @ts-expect-error it's fine
		target[p] = newValue;
		saveState();
		return true;
	},
}) as unknown as PlayerState;

restoreState();
